module.exports = __webpack_public_path__ + "img/custmocount.83cd3dff.jpg";